import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { forgotPassword } from "../../actions/commonActions";
import Spinner from "../UI/Spinner/spinner";
import "./Login.css";
import Logo from "../../Logo.png";

function ForgotPassword() {
  const [userName, setUserName] = useState("");

  const dispatch = useDispatch();
  const { loading, password_reset_success } = useSelector(
    (reduxState) => reduxState.driverProfile
  );

  const formOnSubmit = (e) => {
    e.preventDefault();

    forgotPassword(dispatch, {
      email_address: userName,
      user_role_group_code: "DR",
      vehicle_brand_id: "",
    });
  };

  const userNameChangeHamdler = (e) => {
    setUserName(e.target.value);
  };

  return (
    <div className="parent-div text-center">
      <div>
        <div className="mb-5">
          <img className="" src={Logo} alt="" width="72" height="72" /> <br />
          <span>
            <b>eluTAG</b>
          </span>
          <p>connecting electric vehicle ecosystem</p>
        </div>
        <form className="form-signin" onSubmit={formOnSubmit}>
          <h1 className="h3 font-weight-normal">Forgot Password </h1>
          {password_reset_success && (
            <div class="alert alert-success" role="alert">
              {password_reset_success}
            </div>
          )}
          <label htmlFor="inputEmail" className="sr-only">
            Email address
          </label>
          <input
            type="text"
            id="inputEmail"
            className="form-control"
            placeholder="Email"
            value={userName}
            required=""
            onChange={userNameChangeHamdler}
            autoFocus=""
          />
          {loading ? (
            <Spinner spinnerStyle={"spinner-border text-dark mt-3"} />
          ) : (
            <button
              className="btn btn-sm btn-primary btn-block mt-5 green-two-bg"
              type="submit"
            >
              Reset Password
            </button>
          )}
          <Link to={`/`} className="btn  ">
            Sign In
          </Link>
        </form>
      </div>
    </div>
  );
}

export default ForgotPassword;
